var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4225 1.07745C13.7479 1.40289 13.7479 1.93053 13.4225 2.25596L5.92251 9.75596C5.59707 10.0814 5.06943 10.0814 4.744 9.75596L0.57733 5.5893C0.251893 5.26386 0.251893 4.73622 0.57733 4.41078C0.902767 4.08535 1.4304 4.08535 1.75584 4.41078L5.33325 7.9882L12.244 1.07745C12.5694 0.752015 13.0971 0.752015 13.4225 1.07745Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckWhite);
export default __webpack_public_path__ + "static/media/check-white.3482e07a.svg";
export { ForwardRef as ReactComponent };